<template>
  <article class="magazine-highlight-block">
      <figure class="magazine-highlight-block__image">
        <img :src="getImage" alt="Alt description for the image" />
      </figure>
      <div class="magazine-highlight-block__header">
        <div class="magazine-highlight__title">
              <h2>
                The Main Event
              </h2>
            </div>
      <span>{{ title }}</span>
      </div>
  </article>
</template>
<script>

export default {
  name: 'CardMagazineHighlights',
  props: {
    title: {
      type: String,
      default: 'View product information & download'
    },
    image: {
      type: String,
      default: 'carrier-bags.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.magazine-highlight-block {
  @apply overflow-hidden mb-0;
}
/* .magazine-highlight-block:hover .magazine-highlight-block__image img {
  transform: scale(1.1);
} */
.magazine-highlight-block__image {
  @apply aspect-ratio-16/9 bg-body-dark relative overflow-hidden;
}
.magazine-highlight-block__image img {
  @apply block absolute inset-y-0 inset-x-0 w-full;
}
.magazine-highlight-block__header {
  @apply p-4 pb-0 flex flex-wrap items-center justify-center leading-tight text-center;
}
.magazine-highlight__title {
  @apply mb-2;
}
.magazine-highlight__title h2 {
  @apply text-center w-full font-semibold text-lg;
}
.magazine-highlight-block__header span {
  @apply block text-center w-full;
}
@screen sm {
  .magazine-highlight-block {
    @apply mb-0;
  }
}
@screen md {
  .magazine-highlight-block {
  @apply overflow-hidden mb-6;
}
  .magazine-highlight-block__image {
  border-radius: 1rem;
}
  .magazine-highlight-block__header {
  @apply p-6;
}
}
@screen xl {
  .magazine-highlight__title h2 {
  @apply text-xl;
}
  .magazine-highlight-block__header span {
    @apply text-lg;
  }
}
</style>
